import axios from 'axios';
import { Cookies } from "react-cookie";

const api = axios.create({

    baseURL: process.env.REACT_APP_BASE_URL, // api's base URL should be here
    headers: {
        Accept: "application/json",
        "Content-Type": "application/json"
    },
});

api.interceptors.request.use(
    config => {
        if (typeof FormData !== "undefined" && config.data instanceof FormData) {
            if (config.headers && typeof config.headers.delete === "function") {
                config.headers.delete("Content-Type");
            } else if (config.headers) {
                delete config.headers["Content-Type"];
                delete config.headers["content-type"];
            }
        }
        const cookies = new Cookies();
        const { token, passwordToken } = cookies.getAll();
        if (config.url == 'Authentication/Forgot-Password') {
            config.headers.Authorization = `Bearer ${passwordToken}`
            return config;
        }
        if (token && token != 'null') {
            config.headers.Authorization = `Bearer ${token}`
            return config;
        }
        return config;
    },
    error => {
        return Promise.reject(error,
            
        );
        
        
    }
);

export default api;
